const prefix = '@user';

export const UserActionType = {
  GetPrivateProfile: `${prefix}/GET_PRIVATE_PROFILE`,
  GetCurrentUserComments: `${prefix}/GET_CURRENT_USER_COMMENTS`,
  GetCurrentUserDeals: `${prefix}/GET_CURRENT_USER_DEALS`,
  GetProfileUserByNickname: `${prefix}/GET_PROFILE_USER_BY_NICKNAME`,
  GetDealsByNickname: `${prefix}/GET_DEALS_BY_NICKNAME`,
  getCommentsByNickname: `${prefix}/GET_COMMENTS_BY_NICKNAME`,
  UpdateAvatar: `${prefix}/UPDATE_AVATAR`,
  UpdateNickname: `${prefix}/UPDATE_NICKNAME`,
  ConfirmAccountDeletion: `${prefix}/CONFIRM_ACCOUNT_DELETION`,
  GetUser: `${prefix}/GET_USER`,
  GetUserPreference: `${prefix}/GET_USER_PREFERENCE`,
  UpdateUserPreference: `${prefix}/UPDATE_USER_PREFERENCE`,
};
